<template>
<div class="chapter">
<div class="inner_page">
<h3 class="books-by-head"><em>Recent Titles by Marcia Talley</em></h3>
<p class="books-by-text-space-after"><em>The Hannah Ives Mysteries Series</em></p>
<p class="books-by-text">SING IT TO HER BONES</p>
<p class="books-by-text">UNBREATHED MEMORIES</p>
<p class="books-by-text">OCCASION OF REVENGE</p>
<p class="books-by-text">IN DEATH’S SHADOW</p>
<p class="books-by-text">THIS ENEMY TOWN</p>
<p class="books-by-text">THROUGH THE DARKNESS</p>
<p class="books-by-text">DEAD MAN DANCING *</p>
<p class="books-by-text">WITHOUT A GRAVE *</p>
<p class="books-by-text">ALL THINGS UNDYING *</p>
<p class="books-by-text">A QUIET DEATH *</p>
<p class="books-by-text">THE LAST REFUGE *</p>
<div> </div>
<div> </div>
<p class="books-by-text"><em>* available from Severn House</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?4a2d3dfa